module.exports = __webpack_public_path__ + "static/img/nets.0b30a0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payment_methods/nets.jpg
// module id = CE7W
// module chunks = 1